import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInventory = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.1176 0) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.25 2.1C11.0056 2.1 11.3834 2.1 11.6934 2.18178C12.5345 2.4037 13.1916 3.05061 13.4169 3.87883C13.5 4.18403 13.5 4.55602 13.5 5.3V12.66C13.5 14.0041 13.5 14.6762 13.2343 15.1896C13.0006 15.6412 12.6277 16.0083 12.1691 16.2384C11.6477 16.5 10.9651 16.5 9.6 16.5H4.4C3.03487 16.5 2.35231 16.5 1.8309 16.2384C1.37225 16.0083 0.999363 15.6412 0.765672 15.1896C0.5 14.6762 0.5 14.0041 0.5 12.66V5.3C0.5 4.55602 0.5 4.18403 0.583056 3.87883C0.808444 3.05061 1.46547 2.4037 2.30663 2.18178C2.6166 2.1 2.9944 2.1 3.75 2.1M4.5625 10.9L6.1875 12.5L9.84375 8.9M5.05 3.7H8.95C9.40504 3.7 9.63256 3.7 9.80637 3.61281C9.95925 3.53611 10.0835 3.41372 10.1614 3.26319C10.25 3.09206 10.25 2.86804 10.25 2.42V1.78C10.25 1.33196 10.25 1.10794 10.1614 0.936808C10.0835 0.786278 9.95925 0.663893 9.80637 0.587195C9.63256 0.5 9.40504 0.5 8.95 0.5H5.05C4.59496 0.5 4.36744 0.5 4.19363 0.587195C4.04075 0.663893 3.91645 0.786278 3.83856 0.936808C3.75 1.10794 3.75 1.33196 3.75 1.78V2.42C3.75 2.86804 3.75 3.09206 3.83856 3.26319C3.91645 3.41372 4.04075 3.53611 4.19363 3.61281C4.36744 3.7 4.59496 3.7 5.05 3.7Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgInventory);
export default ForwardRef;
